import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import statuses from './statuses';
import auth from './auth';
import orders from './orders';
import compressedImages from './compressedImages';
import appConfig from './appConfig';
import assets from './assetsReducers';

const RootReducer = combineReducers({
	auth,
	statuses,
	orders,
	compressedImages,
	appConfig,
	assets,
	routing: routerReducer 
});

export default RootReducer;
